import type { Ref } from 'vue'
import type { Options as ConfettiOptions } from 'canvas-confetti'

const prefersReducedMotion = (): boolean => {
  try {
    return window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches === true
  } catch {
    return false
  }
}

/** Two bursts from the player's centre plus a follow-up; skipped for reduced motion. */
export function useConfetti(playerEl: Ref<HTMLElement | null>) {
  return async () => {
    if (prefersReducedMotion()) return

    let originX = 0.5
    let originY = 0.7
    try {
      const el = playerEl.value
      if (el && typeof window !== 'undefined') {
        const rect = el.getBoundingClientRect()
        originX = Math.min(1, Math.max(0, (rect.left + rect.width / 2) / window.innerWidth))
        originY = Math.min(1, Math.max(0, (rect.top + rect.height * 0.55) / window.innerHeight))
      }
    } catch {
      // ignore
    }

    try {
      const confetti = (await import('canvas-confetti')).default
      const base: ConfettiOptions = {
        particleCount: 90,
        spread: 70,
        startVelocity: 45,
        scalar: 0.95,
        ticks: 260,
        origin: { x: originX, y: originY },
      }
      confetti({ ...base, angle: 60 })
      confetti({ ...base, angle: 120 })
      setTimeout(() => {
        try {
          confetti({ ...base, particleCount: 60, spread: 85, startVelocity: 38 })
        } catch {
          // ignore
        }
      }, 450)
    } catch (e) {
      if (import.meta.env.DEV) console.warn('Deckplayer: confetti failed to load', e)
    }
  }
}
